import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { inkLight } from '../../styles/design-tokens';
import { Icon } from '../../ui-library/icon/icon';
import { Text } from '../../ui-library/typography/typography';

export function EmptyFilterResult({ objectName }: { objectName: string }) {
  const i18n = useTranslation();
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <Stack align="center">
        <Icon name="info" color={inkLight} size={40} />
        <Text size="large" weight="medium" color={inkLight}>
          {i18n.t('common.empty_filter.no_objects_found', { objectName })}
        </Text>
        <Text size="medium" weight="medium" color={inkLight}>
          {i18n.t('common.empty_filter.try_different_filter')}
        </Text>
      </Stack>
    </div>
  );
}
